export const DistrictComparativeSalesPerf = {
    "sections": [
      {
        "columns": 4,
        "rows": 1,
        "visual": {
          "id": 14,
          "type": "summary",
          "colorTheme": "colorTheme1",
          "title": "Sales Performance Summary",
          "binding": {
            "data": {
              "title": '',
              "value": '',
              "displayTarget": true,
              "endpoint": "D06",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistrictManagerCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 8,
        "rows": 1,
        "visual": {
          "id": 4,
          "type": "treemap",
          "colorTheme": "colorTheme1",
          "title": "Share by Territories",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "title": 'AgentCode',
              "value": 'Share',
              "tooltip": 'ActualSales',
              "currency": true,
              "percent": true,
              "endpoint": "D18",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistrictManagerCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "DistrictManagerCodeAgentCode",
                  "selectedTitle": "PMR",
                  "visuals": [
                    {
                      "title": "PMR",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": 'colorTheme1',
                            "title": "PMR",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'PMR Code',
                                    "columnName": 'AgentCode',
                                    "width": '150px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false,
                                  },
                                  {
                                    "name": 'Employee Code',
                                    "columnName": 'EmployeeCode',
                                    "width": '160px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false,
                                  },
                                  {
                                    "name": 'PMR Name',
                                    "columnName": 'AgentName',
                                    "width": '200px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false,
                                  },
                                  {
                                    "name": 'Actual Sales',
                                    "columnName": 'ActualSales',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true,
                                  },
                                  {
                                    "name": 'LY Sales',
                                    "columnName": 'LYSales',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true,
                                  },
                                  {
                                    "name": 'Growth %',
                                    "columnName": 'Growth',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Target',
                                    "columnName": 'TargetSales',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true,
                                  },
                                  {
                                    "name": 'Performance %',
                                    "columnName": 'Performance',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  }
                                ],
                                "title": "AgentName",
                                "endpoint": "D18.1",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistrictManagerCodeAgentCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" },
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      "title": "Product Group",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": 'colorTheme1',
                            "title": "Product Group",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'Product Group',
                                    "columnName": 'ItemDivisionCode',
                                    "width": '200px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false,
                                  },
                                  {
                                    "name": 'Actual Sales',
                                    "columnName": 'ActualSales',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true,
                                  },
                                  {
                                    "name": 'LY Sales',
                                    "columnName": 'LYSales',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true,
                                  },
                                  {
                                    "name": 'Growth %',
                                    "columnName": 'Growth',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Target',
                                    "columnName": 'TargetSales',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true,
                                  },
                                  {
                                    "name": 'Performance %',
                                    "columnName": 'Performance',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  }
                                ],
                                "title": "ItemDivisionCode",
                                "endpoint": "D18.2",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistrictManagerCodeAgentCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" },
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 6,
        "rows": 1,
        "visual": {
          "id": 1,
          "type": "combo",
          "colorTheme": 'colorTheme1',
          "title": "Actual Sales vs Target",
          "orientation": "vertical",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
                {
                  "name": 'Sales',
                  "value": 'Sales',
                  "type": 'column'
                },
                {
                  "name": 'Target',
                  "value": 'Target',
                  "type": 'column'
                },
                {
                  "name": 'Performance %',
                  "value": 'Performance',
                  "type": 'line',
                  "percent": true
                }
              ],
              "title": "Month",
              "endpoint": "D24",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistrictManagerCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 6,
        "rows": 2,
        "visual": {
          "id": 13,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "District Product Group",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'District Manager Code',
                  "columnName": 'DistrictManagerCode',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                },
                {
                  "name": 'District Manager Name',
                  "columnName": 'DistrictManagerName',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                },
                {
                  "name": 'Actual Sales',
                  "columnName": 'ActualSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true,
                },
                {
                  "name": 'LY Sales',
                  "columnName": 'LYSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true,
                },
                {
                  "name": 'Growth %',
                  "columnName": 'Growth',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                },
                {
                  "name": 'Target',
                  "columnName": 'TargetSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true,
                },
                {
                  "name": 'Performance %',
                  "columnName": 'Performance',
                  "width": '150px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                }
              ],
              "title": "DistrictManagerName",
              "endpoint": "D38",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistrictManagerCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "DistrictManagerCodeDistrictManagerName",
                  "selectedTitle": "PMR",
                  "visual": [
                    {
                      "columns": 12,
                      "rows": 2,
                      "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": 'colorTheme1',
                        "title": "PMR",
                        "binding": {
                          "data": {
                            "columns": [
                              {
                                "name": 'PMR Code',
                                "columnName": 'AgentCode',
                                "width": '200px',
                                "align": "left",
                                "sortable": true
                              },
                              {
                                "name": 'Employee Code',
                                "columnName": 'EmployeeCode',
                                "width": '200px',
                                "align": "left",
                                "sortable": true
                              },
                              {
                                "name": 'PMR Name',
                                "columnName": 'AgentName',
                                "width": '200px',
                                "align": "left",
                                "sortable": true
                              },
                              {
                                "name": 'Actual Sales',
                                "columnName": 'ActualSales',
                                "width": '140px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                              },
                              {
                                "name": 'LY Sales',
                                "columnName": 'LYSales',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                              },
                              {
                                "name": 'Growth %',
                                "columnName": 'Growth',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                              },
                              {
                                "name": 'Target',
                                "columnName": 'TargetSales',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                              },
                              {
                                "name": 'Performance %',
                                "columnName": 'Performance',
                                "width": '150px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                              }
                            ],
                            "title": "AgentName",
                            "endpoint": "D38.1",
                            "parameters": [
                              { "key": "FromMonth", "value": "2024" },
                              { "key": "FromYear", "value": "1" },
                              { "key": "ToMonth", "value": "2024" },
                              { "key": "ToYear", "value": "1" },
                              { "key": "DistrictManagerCode", "value": "" },
                              { "key": "DistrictManagerCodeDistrictManagerName", "value": "" },
                              { "key": "ConfigTypeCode", "value": "" }
                            ]
                          },
                          "context": {
                            "point": {
                              "onClick": {
                                "selectedValueColumn": "DistrictManagerCodeAgentCode",
                                "selectedTitle": "Product Group",
                                "visual": [
                                  {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                      "id": 1,
                                      "type": "advancedTable",
                                      "colorTheme": 'colorTheme1',
                                      "title": "Product Group",
                                      "binding": {
                                        "data": {
                                          "columns": [
                                            {
                                              "name": 'Product Group',
                                              "columnName": 'ItemDivisionCode',
                                              "width": '200px',
                                              "align": "left",
                                              "sortable": true
                                            },
                                            {
                                              "name": 'Actual Sales',
                                              "columnName": 'ActualSales',
                                              "width": '140px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": true,
                                            },
                                            {
                                              "name": 'LY Sales',
                                              "columnName": 'LYSales',
                                              "width": '125px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": true,
                                            },
                                            {
                                              "name": 'Growth %',
                                              "columnName": 'Growth',
                                              "width": '125px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": false,
                                              "percent": true
                                            },
                                            {
                                              "name": 'Target',
                                              "columnName": 'TargetSales',
                                              "width": '125px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": true,
                                            },
                                            {
                                              "name": 'Performance %',
                                              "columnName": 'Performance',
                                              "width": '150px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": false,
                                              "percent": true
                                            }
                                          ],
                                          "title": "ItemDivisionCode",
                                          "endpoint": "D38.2",
                                          "parameters": [
                                            { "key": "FromMonth", "value": "2024" },
                                            { "key": "FromYear", "value": "1" },
                                            { "key": "ToMonth", "value": "2024" },
                                            { "key": "ToYear", "value": "1" },
                                            { "key": "DistrictManagerCode", "value": "" },
                                            { "key": "DistrictManagerCodeAgentCode", "value": "" },
                                            { "key": "ConfigTypeCode", "value": "" }
                                          ]
                                        },
                                        "context": {
                                          "point": {
                                            "onClick": {
                                              "selectedValueColumn": "DistrictCodeAgentCodeItemDivisionCode",
                                              "selectedTitle": "Product",
                                              "visual": [
                                                {
                                                  "columns": 12,
                                                  "rows": 2,
                                                  "visual": {
                                                    "id": 1,
                                                    "type": "advancedTable",
                                                    "colorTheme": 'colorTheme1',
                                                    "title": "Product",
                                                    "binding": {
                                                      "data": {
                                                        "columns": [
                                                          {
                                                            "name": 'Product Name',
                                                            "columnName": 'ItemName',
                                                            "width": '200px',
                                                            "align": "left",
                                                            "sortable": true
                                                          },
                                                          {
                                                            "name": 'Actual Sales',
                                                            "columnName": 'ActualSales',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true,
                                                          },
                                                          {
                                                            "name": 'LY Sales',
                                                            "columnName": 'LYSales',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true,
                                                          },
                                                          {
                                                            "name": 'Growth %',
                                                            "columnName": 'Growth',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                          },
                                                          {
                                                            "name": 'Target',
                                                            "columnName": 'TargetSales',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true,
                                                          },
                                                          {
                                                            "name": 'Performance %',
                                                            "columnName": 'Performance',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                          }
                                                        ],
                                                        "title": "ItemName",
                                                        "endpoint": "D38.3",
                                                        "parameters": [
                                                          { "key": "FromMonth", "value": "2024" },
                                                          { "key": "FromYear", "value": "1" },
                                                          { "key": "ToMonth", "value": "2024" },
                                                          { "key": "ToYear", "value": "1" },
                                                          { "key": "DistrictManagerCode", "value": "" },
                                                          { "key": "DistrictCodeAgentCodeItemDivisionCode", "value": "" },
                                                          { "key": "ConfigTypeCode", "value": "" }
                                                        ]
                                                      },
                                                      "context": {
                                                        "point": {
                                                          "onClick": {
  
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                ]
                              }
                            }
                          }
                        }
                      }
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 6,
        "rows": 1,
        "visual": {
          "id": 1,
          "type": "combo",
          "colorTheme": 'colorTheme1',
          "title": "This Year Sales vs Last Year",
          "orientation": "vertical",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
                {
                  "name": 'Sales',
                  "value": 'ActualSales',
                  "type": 'column'
                },
                {
                  "name": 'LY Sales',
                  "value": 'LYSales',
                  "type": 'column'
                },
                {
                  "name": 'Growth %',
                  "value": 'Growth',
                  "type": 'line',
                  "percent": true
                }
              ],
              "title": "Month",
              "endpoint": "D23",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistrictManagerCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": 'colorTheme1',
          "title": "Employee Comparative Sales",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Employee Code',
                  "columnName": 'EmployeeCode',
                  "width": '160px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Employee Name',
                  "columnName": 'AgentName',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Jan',
                  "columnName": 'Jan',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Feb',
                  "columnName": 'Feb',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Mar',
                  "columnName": 'Mar',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Apr',
                  "columnName": 'Apr',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'May',
                  "columnName": 'May',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Jun',
                  "columnName": 'Jun',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Jul',
                  "columnName": 'Jul',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Aug',
                  "columnName": 'Aug',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Sep',
                  "columnName": 'Sep',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Oct',
                  "columnName": 'Oct',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Nov',
                  "columnName": 'Nov',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Dec',
                  "columnName": 'Dec',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Total Sales',
                  "columnName": 'TotalSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                }
              ],
              "title": "DistrictManagerName",
              "endpoint": "D38.4",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "DistrictManagerCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": 'colorTheme1',
          "title": "Employee Growth and Performance",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Employee Code',
                  "columnName": 'EmployeeCode',
                  "width": '160px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Employee Name',
                  "columnName": 'AgentName',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Actual Sales',
                  "columnName": 'ActualSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true,
                },
                {
                  "name": 'LY Sales',
                  "columnName": 'LYSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true,
                },
                {
                  "name": 'Growth %',
                  "columnName": 'Growth',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                },
                {
                  "name": 'Target',
                  "columnName": 'TargetSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true,
                },
                {
                  "name": 'Performance %',
                  "columnName": 'Performance',
                  "width": '150px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                }
              ],
              "title": "DistrictManagerName",
              "endpoint": "D38.5",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "DistrictManagerCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                }
              }
            }
          }
        }
      }
    ]
  }